import './MapContainer.scss'


export const MapContainer = (props) => {

    return (
        <div className='map-container container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <img className='popup-map' alt='map' src={props.link}></img>
                </div>
            </div>
        </div>
    )
}






